import { useAppSelector } from "../../../hooks/app";
import { getRequestFormData } from "../../../store/slices/request-signature.slice";

function StepZero({ handleSignatureType, type }: { handleSignatureType: any, type: string }) {
    const requestFormData = useAppSelector(getRequestFormData)
    return (
        <div className="signature_step__two">
            <h3 className="heading3 text-center">Select the request type you want.</h3>
            <div className="input_group">
                <label>Request Signature Type</label>
                <select className="w-100" onChange={handleSignatureType} value={requestFormData?.type}>
                    <option value="">Select</option>
                    <option value="0">Flight</option>
                    <option value="1">Endorsement</option>
                    <option value="2">Rating</option>
                </select>
            </div>
        </div>
    );
}

export default StepZero;
